module.exports = __webpack_public_path__ + "img/google-plus_circled.94b3ad17.svg";